import React, { useEffect, useState, useRef } from 'react';
import { auth } from '../components/firebase'; 
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Login = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [confirmationResult, setConfirmationResult] = useState(null);
  const inputRefs = useRef([...Array(6)].map(() => React.createRef()));

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (token) {
      navigate('/home');
      return;
    }

    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        'send-otp',
        {
          size: 'invisible',
          callback: (response) => {
            console.log('reCAPTCHA verified:', response);
          },
          'expired-callback': () => {
            console.error('reCAPTCHA expired. Please reload the page.');
          },
        }
      );
    }
  }, [navigate]);

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== '' && index < 5) {
      inputRefs.current[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      inputRefs.current[index - 1].current.focus();
    }
  };

  const handleSendOtp = async () => {
    try {
      const appVerifier = window.recaptchaVerifier;
      const result = await signInWithPhoneNumber(auth, `+${phoneNumber}`, appVerifier);
      setConfirmationResult(result);
      alert('OTP sent successfully!');
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert('Failed to send OTP. Please try again.');
    }
  };

  const handleVerifyOtp = async () => {
    try {
      if (!confirmationResult) {
        alert('Please send OTP first');
        return;
      }

      const otpString = otp.join('');
      const result = await confirmationResult.confirm(otpString);
      const user = result.user;
      const idToken = await user.getIdToken();
      
      localStorage.setItem("idToken", idToken);
      alert(`Logged in as: ${user.phoneNumber}`);
      navigate('/home');
    } catch (error) {
      console.error('Error verifying OTP:', error);
      alert('Invalid OTP. Please try again.');
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-lg rounded-4">
              <div className="card-body p-4">
                {/* Header */}
                <div className="text-center mb-4">
                  <h2 className="h4 mb-1">Welcome</h2>
                  <p className="text-muted small">Login with your phone number</p>
                </div>

                {/* Phone Number Input */}
                <div className="mb-4">
                  <label className="form-label small text-muted">Phone Number</label>
                  <PhoneInput
                    country={'in'}
                    value={phoneNumber}
                    onChange={setPhoneNumber}
                    inputClass="w-100"
                    containerClass="mb-3"
                  />
                  <button 
                    id="send-otp" 
                    onClick={handleSendOtp}
                    className="btn custom-emerald text-white w-100 mt-3 rounded-3 py-2 rounded-pill"
                  >
                    Send OTP
                  </button>
                </div>

                {/* OTP Input Boxes */}
                <div className="mb-4">
                  <label className="form-label small text-muted">Enter OTP</label>
                  <div className="d-flex gap-2 justify-content-between mb-3">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        ref={inputRefs.current[index]}
                        type="text"
                        maxLength="1"
                        className="form-control form-control-lg text-center otp-input border-success"
                        value={digit}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                      />
                    ))}
                  </div>
                  <button 
                    id="verify-otp" 
                    onClick={handleVerifyOtp}
                    className="btn w-100 py-2 rounded-pill custom-emerald text-white"
                  >
                    Verify & Login
                  </button>
                </div>

                {/* Additional Info */}
                <div className="text-center mt-4">
                  <p className="text-muted small mb-0">
                    By continuing, you agree to our Terms of Service and Privacy Policy
                  </p>
                </div>

                {/* reCAPTCHA Container */}
                <div id="recaptcha-container" className="mt-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;